import { Emitter } from "@pixi/particle-emitter";
import { IGameAnimation } from "by/gamefactory/animations/IGameAnimation";
import { PromiseCompletionSource } from "by/gamefactory/shared/async/PromiseCompletionSource";
import { Container, Point, Texture } from "pixi.js";

export class BrokenShieldAnimation implements IGameAnimation {
    private animationContainer: Container;
    private particles: Texture[];
    private positions: Point[];

    public constructor(
        animationContainer: Container,
        particles: Texture[],
        positions: Point[]
    ) {
        this.animationContainer = animationContainer;
        this.particles = particles;
        this.positions = positions;
    }

    public async play(): Promise<void> {
        const emitter = new Emitter(this.animationContainer, {
            "lifetime": {
                "min": 2,
                "max": 2
            },
            "emit": false,
            "autoUpdate": true,
            "frequency": 1 / this.particles.length,
            "emitterLifetime": 2,
            "maxParticles": this.particles.length,
            "addAtBack": false,
            "particlesPerWave": this.particles.length,
            "pos": {
                "x": 0,
                "y": 0
            },
            "behaviors": [
                {
                    "type": "alpha",
                    "config": {
                        "alpha": {
                            "list": [
                                {
                                    "time": 0,
                                    "value": 0
                                },
                                {
                                    "time": 0.1,
                                    "value": 1
                                },
                                {
                                    "time": 0.3,
                                    "value": 1
                                },
                                {
                                    "time": 1,
                                    "value": 0
                                }
                            ]
                        }
                    }
                },
                {
                    "type": "textureOrderedStartPositions",
                    "config": {
                        "textures": this.particles,
                        "positions": this.positions
                    }
                },
                {
                    "type": "moveAcceleration",
                    "config": {
                        "accel": {
                            "x": 0,
                            "y": 200
                        },
                        "minStart": 0,
                        "maxStart": 20,
                        "rotate": false
                    }
                },
                {
                    "type": "scale",
                    "config": {
                        "scale": {
                            "list": [
                                {
                                    "time": 0,
                                    "value": 1.0
                                },
                                {
                                    "time": 0.3,
                                    "value": 0.6
                                },
                                {
                                    "time": 1,
                                    "value": 0.1
                                }
                            ]
                        },
                        "minMult": 1
                    }
                },
                {
                    "type": "rotation",
                    "config": {
                        "minStart": 0,
                        "maxStart": 0,
                        "minSpeed": -10,
                        "maxSpeed": 10,
                        "accel": 20
                    }
                }
            ]
        });
        const untilComplete = new PromiseCompletionSource<void>();
        emitter.playOnce(() => {
            untilComplete.complete();
        });
        await untilComplete.result;
        emitter.destroy();
    }

}